import type { StyleSystemProps } from '@withjoy/joykit';
import { Box, SpacingStack, styled } from '@withjoy/joykit';
export const StyledContent = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: static;
  left: 0;
  background: transparent;
`;

export const StyledHeaderStack = styled(Box)`
  margin-bottom: 32px;
`;

export const StyledTitleStack = styled(SpacingStack)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  > *:not(:first-child) {
    margin-top: 0.5rem;
  }
`;

export const StyledFormStack = styled(SpacingStack)``;

export const StyledInputsStack = styled(SpacingStack).attrs({ spacing: 4 })`
  margin-bottom: 32px;
`;

export const StyledLinksStack = styled(SpacingStack)`
  justify-content: space-between;
  margin-top: 24px;
`;

const contentStyles: StyleSystemProps = {
  padding: ['24px 48px 24px', '32px 48px 48px'],
  width: '100%',
};

const formStackStyles: StyleSystemProps = {
  width: '100%',
};

const unlockedContentStyles: StyleSystemProps = {
  height: ['100%', '530px'],
  backgroundColor: 'transparent',
  alignItems: 'center',
};

export const styles = {
  content: contentStyles,
  formStack: formStackStyles,
  unlockedContent: unlockedContentStyles,
};
